import React, { useEffect, useState } from 'react';
import API from '../services/api';

function TherapistMessagesPage() {
  const [messages, setMessages] = useState([]);
  // Change default to `true` so it initially shows only unread messages
  const [showUnreadOnly, setShowUnreadOnly] = useState(true);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      // Still fetches all messages from the server,
      // but we only display unread by default locally.
      const res = await API.get('/therapist/messages');
      setMessages(res.data);
    } catch (err) {
      console.error(err);
      alert('Error fetching messages');
    }
  };

  const handleToggleUnreadOnly = () => {
    setShowUnreadOnly(!showUnreadOnly);
  };

  // Filter in the front end if showUnreadOnly
  const displayedMessages = showUnreadOnly 
    ? messages.filter(msg => !msg.is_read)
    : messages;

  // Mark read/unread
  const updateReadStatus = async (messageId, newReadStatus) => {
    try {
      await API.put(`/therapist/messages/${messageId}`, { isRead: newReadStatus });
      setMessages(prev =>
        prev.map(m =>
          m.id === messageId
            ? { ...m, is_read: newReadStatus, read_at: newReadStatus ? new Date().toISOString() : null }
            : m
        )
      );
    } catch (err) {
      console.error('Error updating read status:', err);
      alert('Error updating read status');
    }
  };

  return (
    <div style={{ margin: '2rem' }}>
      <h2>Therapist Messages</h2>

      <label style={{ marginRight: '1rem' }}>
        <input 
          type="checkbox"
          checked={showUnreadOnly}
          onChange={handleToggleUnreadOnly}
        />
        Show Unread Only
      </label>

      {displayedMessages.length === 0 
        ? <p>No messages found.</p>
        : displayedMessages.map(msg => (
            <div
              key={msg.id}
              style={{
                border: '1px solid #ccc',
                padding: '1rem',
                marginBottom: '1rem'
              }}
            >
              <h4>
                {msg.title}{' '}
                {!msg.is_read && <span style={{ color: 'red' }}>(Unread)</span>}
              </h4>

              {/* Render the message content as HTML */}
              <p 
                dangerouslySetInnerHTML={{ __html: msg.content }}
              />

              {msg.image_url && (
                <img
                  src={msg.image_url}
                  alt="Message"
                  style={{
                    maxWidth: '200px',
                    display: 'block',
                    marginBottom: '0.5rem'
                  }}
                />
              )}

              <small>Posted on {new Date(msg.created_at).toLocaleString()}</small>
              <br/>
              {msg.is_read ? (
                <button onClick={() => updateReadStatus(msg.id, false)}>
                  Mark Unread
                </button>
              ) : (
                <button onClick={() => updateReadStatus(msg.id, true)}>
                  Mark Read
                </button>
              )}
            </div>
          ))
      }
    </div>
  );
}

export default TherapistMessagesPage;
